import styled from 'styled-components';

export const Container = styled.div`
  background-color: #0000c9;
`;

export const Content = styled.div`
  max-width: 1120px;
  margin: 0 auto;
  padding: 10px 24px 9px;
`;

export const Wraper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1em 0;

  @media (max-width: 425px) {
    flex-direction: column;
    gap: 26px;
  }
`;

export const WraperCentralRelations = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;

  @media (max-width: 425px) {
    flex-direction: column;
  }
`;

export const AlignLogoSebraeFooter = styled.div`
  margin-left: 24px;
`;

export const WraperStores = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  a {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 33px;
    height: 33px;
    border-radius: 50%;

    &:hover {
      background-color: #000;
    }
  }
`;

export const AlignCenter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 0;
  border-top: 1px solid #fff;
`;

export const ContentCentralRelacionamento = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  p,
  strong {
    color: #fff;
    font-family: 'Inter', sans-serif;
  }

  p {
    font-size: 13px;
  }

  strong {
    font-size: 23px;
  }
`;

export const GoToTopButton = styled.div`
  position: relative;

  &::after {
    content: '↑ Voltar ao topo';
    position: absolute;
    top: -44px;
    left: 10px;
    background-color: #007bff;
    color: white;
    padding: 16px;
    border-radius: 14px 14px 0 0;
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;
    text-align: center;
    transition: background-color 0.3s ease;

    z-index: 10;
  }

  &::after:hover {
    background-color: #0056b3;
  }
`;

//new css

export const ContainerMedias = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 425px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const AlignStores = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  a {
    padding: 8px;
    transition: background-color 0.3s ease-in;
    border-radius: 50%;

    &:hover {
      background-color: rgb(12, 12, 122);
    }
  }
  img {
    width: 20px;
    height: 20px;
  }
`;
